<div class="map-container">

    <app-map id="status-map"
        [items]="mapItems"
        leafletId="leaflet-status-map"
        baseMapName="Water color"
        [viewOnly]="true">
    </app-map>

</div>